<form [formGroup]="form" (submit)="search()">
  <pulse-input
    formControlName="search"
    floatLabel="never"
    label="Company name"
    placeholder="Company name"
  >
    <div pls-sufix>
      <pulse-icon
        class="cursor-pointer hover:text-primary-500"
        (click)="search()"
        icon="search"
      ></pulse-icon>
    </div>
  </pulse-input>
</form>
